/* unplugin-vue-components disabled */import { render } from "./ArticleEdit.vue?vue&type=template&id=6d35146c&scoped=true"
import script from "./ArticleEdit.vue?vue&type=script&lang=js"
export * from "./ArticleEdit.vue?vue&type=script&lang=js"

import "./ArticleEdit.vue?vue&type=style&index=0&id=6d35146c&lang=less&scoped=true"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d35146c"]])

export default __exports__